
function selectOptionByValue(id, valueToSelect) {
    const selectElement = document.querySelector(id);
    for (const option of selectElement.options) {
      if (option.value === valueToSelect) {
        option.selected = true;
        break;
      }
    }
    // Update the span within the button based on selected value
    updateButtonSpan(valueToSelect);
  }

  function updateButtonSpan(selectedValue) {
    const buttonSpan = document.querySelector('.button-purchase span');
    buttonSpan.textContent = selectedValue === 'Pick Option' ? 'Select an option' : 'Foundation brand';
  }
  window.addEventListener('load', function () {
    if (shadeSelect) {
      selectOptionByValue('.select__select', 'Pick Option');
    }
    
  });
  // Select handling using class
  const shadeSelect = document.querySelector('.select__select'); // Target by class
  if (shadeSelect) {
    shadeSelect.addEventListener('change', function (event) {
      const selectedOption = event.target.options[event.target.selectedIndex];
      const colorName = selectedOption.text;
      // Get the shades description from the selected option's dataset
      const shadesDescription = selectedOption.dataset.currentShadesDescription;
      // Update the shades description display (unified logic)
      const shadesDescriptionElement = document.querySelector('.shade-description .shade-box regular-font');
      if (shadesDescriptionElement) {
        if (shadesDescription) {
          shadesDescriptionElement.textContent = '- ' + shadesDescription;
        }
      } else {
        console.warn("Element with class 'shade-description .h4' not found");
      }
    });
  } 
